import { CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const Details = ({
    shipping_address, selected, inModal,
    handleSelectShippingAddress, toggleAddAddress,
}) => {
    let countryName = null;
    if (
        shipping_address.country &&
        shipping_address.country.length > 0 &&
        shipping_address.country[0].toUpperCase() !== "IN"
    ) {
        countryName = shipping_address.country[1];
    }

    return (
        <CardContent className="cursor-default px-3 py-3 mt-3 flex border border-slate-300 rounded-sm">
            <div className="min-w-[8%] px-2 flex flex-col items-center justify-center">
                <input
                    type="radio"
                    value={selected === true}
                    checked={selected === true}
                    className="w-[20px] h-[20px] cursor-pointer"
                    onChange={() => handleSelectShippingAddress(shipping_address.pk)}
                />
            </div>

            <div className="flex-1 text-sm tracking-wide">
                <p className="mt-1">
                    {shipping_address.full_name}
                </p>

                <p className="mt-1">
                    Ph No:- {shipping_address.phone_0}-{shipping_address.phone_1}
                </p>

                <p className="mt-1 line-clamp-3	text-ellipsis overflow-hidden">
                    {shipping_address.street_address &&
                        `${shipping_address.street_address}`}
                    {shipping_address.city_area && `, ${shipping_address.city_area}`}
                    {shipping_address.city && `, ${shipping_address.city}`}
                    {shipping_address.country_area &&
                        `, ${shipping_address.country_area}`}
                    {shipping_address.pin_code && `, ${shipping_address.pin_code}`}
                </p>

                {countryName && (
                    <p className="mt-1">
                        {countryName}
                    </p>
                )}
            </div>

            <div className="min-w-[8%] flex justify-end">
                <Button
                    variant="secondary"
                    className="
                        bg-white hover:bg-white rounded-none 
                        px-2 py-0 h-[45px] border-0 underline
                        items-center justify-between cursor-pointer 
                    "
                    onClick={() => toggleAddAddress({ 
                        value: true, 
                        shippingData: inModal ?  shipping_address : null,
                        addressValid: false
                    })}
                >
                    Edit
                </Button>
            </div>
        </CardContent>
    )
}

export default Details